import React, { useState, useContext, useEffect } from 'react';
import * as S from './styles_M.Cotacao';
import { Context } from '../../services/contexts/StateContext';
import api from '../../services/api';
import { useLocation } from 'react-router-dom';
// -----------------------
import { SetFunctions } from '../Functions';
import { Api_Veiculos } from '../../services/FiltrosApi/veiculos_api';
// ----------------------------------------

export function ModalCotacao_PREVIEW(props) {
    const { state, dispatch } = useContext(Context);
    const { veiculo } = state.veiculo;
    const { parametroInit, listaPesquisa } = state.parametros;

    const { SetVeiculo } = SetFunctions();
    // ----------------------
    const [editandoValorFipe, setEditandoValorFipe] = useState(false);
    const [valorFipeDigitado, setValorFipeDigitado] = useState('');
    const [rotaCotacao, setrotaCotacao] = useState(false);

    const localRota = useLocation();
    const { AtualizarVeiculo } = Api_Veiculos();

    // ###############################################################################

    useEffect(() => {
        if (localRota.pathname === "/cotacao") {
            setrotaCotacao(true)
        } else {
            setrotaCotacao(false)
        };
    }, []);

    // ------------------------------
    const salvarValorFipe = () => {
        if (!valorFipeDigitado || valorFipeDigitado.trim() === '') {
            alert('Por favor, digite um valor válido.');
            return;
        }

        // Converter para número e validar
        const valorNumerico = parseFloat(valorFipeDigitado.replace(/\D/g, ''));
        
        if (isNaN(valorNumerico) || valorNumerico <= 0) {
            alert('Por favor, digite um valor numérico válido.');
            return;
        }

        // Atualizar o estado do veículo com o valor digitado
        dispatch({
            type: 'set_veiculo',
            payload: {
                ...veiculo,
                valorFipe: valorNumerico.toString()
            }
        });

        // Fechar o input de edição
        setEditandoValorFipe(false);
        setValorFipeDigitado('');
    };

    // ------------------------------
    const abrirEdicaoValorFipe = () => {
        setEditandoValorFipe(true);
        setValorFipeDigitado(veiculo.valorFipe || '');
    };
    
    // -----------------------

    function SelectModeloScore(modelo) {
        // filtrar de props.maioresScoresFipe o item que tem texto_modelo igual ao selecionado
        const modeloSelecionado = props.maioresScoresFipe.find(item => item.texto_modelo === modelo);
        if (modeloSelecionado) {
            const valorNumerico = modeloSelecionado.texto_valor
                .replace('R$', '')
                .replace(/\./g, '')
                .replace(',', '.')
                .trim();

            dispatch({
                type: 'set_veiculo',
                payload: {
                    ...veiculo,
                    modelo: modeloSelecionado.texto_modelo,
                    valorFipe: valorNumerico,
                }
            });
        };
    }; 
    // ---------------------------  
    useEffect(() => {
        if (listaPesquisa.listaVeiculo.length > 0 && props.dadosFipeRecebidos && veiculo.modelo && veiculo.valorFipe ) {
            AtualizarVeiculo({idCliente: null})
            
        }
    }, [veiculo.modelo, veiculo.valorFipe])
    
    // -------------------------------
    function EditarModelo(placa) {
        SetVeiculo('modelo', '');
        props.BuscarPlacaFipe(placa)
        
    }

    // -------------------------------
    const CotacaoValor = async () => {
        props.setvalorMensal('');
        if (!veiculo.valorFipe) {
            console.log('Digite um número para buscar.');
            return;
        };
        try {
            const TipoForm = veiculo.marca === "yamaha" ? "yamaha" : veiculo.tipo;

            const res = await api.get('/vistoria/buscarFaixaPreco', {
                params: { 
                    numero: veiculo.valorFipe,
                    tipoVeiculo: TipoForm
                }
            });

            props.setvalorMensal( res.data.valor);

            dispatch({
                type: 'set_veiculo',
                payload: {
                    ...veiculo,
                    valorMensal: res.data.valor
                }
            }); 

            return res.data

        } catch (err) {
            alert('Valor de Plano não encontrado!');
        }
    };

    // -------------------------------------------

    useEffect(() => {
        if (veiculo.valorFipe && veiculo.tipo && props.fazerCotacao) {
            CotacaoValor();
        }
    }, [veiculo.valorFipe, veiculo.tipo])
    // ----------------------

    //###################################################################################
    return (
        <S.body
            detalhesLista={parametroInit.detalhesLista}
            fundoBloque = {false}
        >
            <S.Container> 
                <S.div3>
                    <div style={{ 
                        width: '88vw',
                        maxWidth: '400px',
                        backgroundColor: '#1a1a2e',
                        border: '2px solid #00D594',
                        borderRadius: '10px',
                        padding: '10px',
                        marginTop: '15px'
                    }}>
                        <div style={{ 
                            textAlign: 'center',
                            marginBottom: '15px',
                            borderBottom: '1px solid #00D594',
                            paddingBottom: '10px'
                        }}>
                            <span style={{ 
                                color: '#00D594',
                                fontSize: '15px',
                                fontWeight: 'bold'
                            }}>
                                📋 DADOS DA PLACA: <span style={{color:"white"}}>{veiculo?.placa}</span>
                            </span>
                        </div>

                        <div style={{ display: 'flex',gap: '10px',marginBottom: '15px'}}>
                            <div className='listaFlexCol'>
                                <span style={{ color: '#FFD700', fontSize: '12px' }}>TIPO:</span>
                                {veiculo.tipo ?
                                <span style={{ color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>
                                    {veiculo.tipo }
                                </span>
                                :
                                <select
                                disabled={!veiculo.modelo}
                                value={veiculo.tipo || ''}
                                onChange={e => SetVeiculo('tipo', e.target.value)}
                                style={{
                                    backgroundColor: '#333',
                                    color: 'white',
                                    padding: '5px',
                                    borderRadius: '5px',
                                    border: `1px solid ${veiculo.modelo ? '#f12525' : '#555'}`,
                                    fontWeight: 'bold',
                                    textTransform: 'uppercase',
                                    fontSize: '12px',
                                }}
                                >
                                    <option value="" hidden>SELECIONE TIPO</option>
                                    <option value="automovel">AUTOMÓVEL</option>
                                    <option value="motocicleta">MOTOCICLETA</option>
                                    <option value="caminhao">CAMINHÃO</option>
                                </select>
                                }
                            </div>
                            
                            <div className='listaFlexCol' style={{flex: "0.6"}}>
                                <span style={{ color: '#FFD700', fontSize: '12px' }}>MARCA:</span>
                                <span style={{ color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>
                                    {veiculo.marca ? veiculo.marca : '-'}
                                </span>
                            </div>
                            <div className='listaFlexCol' style={{flex: "0.6"}}>
                                <span style={{ color: '#FFD700', fontSize: '12px' }}>ANO:</span>
                                <span style={{ color: 'white', fontWeight: 'bold' }}>
                                    {veiculo.anoMod ? veiculo?.anoMod : '-'}
                                </span>
                            </div>
                        </div>

                        <div style={{ 
                            display: 'flex',
                            gap: '10px',
                            marginBottom: '15px'
                        }}>

                        {/* Criar um Select para escolher o modelo no array props.maioresScoresFipe */
                            !veiculo.modelo && props.maioresScoresFipe.length > 1 ?
                            <select 
                                value={veiculo?.modelo}
                                onChange={e => SelectModeloScore(e.target.value)}
                                style={{ 
                                    backgroundColor: '#333',
                                    color: 'white',
                                    padding: '5px',
                                    borderRadius: '5px',
                                    border: `1px solid ${!veiculo.modelo ? '#f12525' : '#555'}`,
                                    fontWeight: 'bold',
                                    textTransform: 'uppercase',
                                    fontSize: '12px',
                                    flex: 1
                                }}
                            >
                                <option value="" hidden>SELECIONE MODELO</option>
                                {props.maioresScoresFipe.map((item, index) => (
                                    <option key={index} value={item.texto_modelo}>
                                        {item.texto_modelo}
                                    </option>
                                ))}
                            </select>
                            
                            :

                            <div 
                            onClick={() => EditarModelo(veiculo.placa)} 
                            style={{cursor:"pointer"}}
                            className='listaFlexCol'
                            >
                                <span style={{ color: '#FFD700', fontSize: '12px' }}>MODELO:</span>
                                <span style={{ color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>
                                    {veiculo?.modelo || '-'}
                                </span>
                            </div>
                            
                            /* ---------- */}
                                

                            {veiculo.modelo && 
                            <>
                            <div className='listaFlexCol'>
                                <span style={{ color: '#FFD700', fontSize: '12px' }}>VALOR FIPE:</span>
                                {veiculo.valorFipe ? 
                                <span style={{ color: '#00FF00', fontWeight: 'bold', fontSize: 'clamp(12px, 3vw, 16px)' }}>
                                    {parseFloat(veiculo.valorFipe).toLocaleString('pt-BR', {
                                        style: 'currency', currency: 'BRL',
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}
                                </span>
                                : 
                                editandoValorFipe ? (
                                // Modo de edição: mostrar input
                                <input
                                    type='text'
                                    value={valorFipeDigitado}
                                    onChange={e => setValorFipeDigitado(e.target.value)}
                                    onKeyPress={e => {
                                        if (e.key === 'Enter') {
                                            salvarValorFipe();
                                        }
                                    }}
                                    onBlur={salvarValorFipe}
                                    placeholder='valor fipe'
                                    autoFocus
                                    style={{
                                        backgroundColor: '#333',
                                        color: 'white',
                                        padding: '2px 4px',
                                        borderRadius: '5px',
                                        border: '1px solid #FFD700',
                                        fontWeight: 'bold',
                                        fontSize: 'clamp(12px, 3vw, 16px)',
                                        width: '90%',
                                        outline: 'none'
                                    }}
                                />
                                ) 
                                : 
                                veiculo.valorFipe ? (
                                // Se já tem valor salvo, mostrar com opção de editar
                                <div
                                    onClick={abrirEdicaoValorFipe}
                                    style={{
                                        color: '#00FF00',
                                        fontWeight: 'bold',
                                        fontSize: 'clamp(12px, 3vw, 16px)',
                                        cursor: 'pointer',
                                        padding: '2px 3px',
                                        borderRadius: '5px',
                                        transition: 'all 0.3s ease',
                                        border: '2px solid transparent'
                                    }}
                                    onMouseEnter={e => {
                                        e.target.style.backgroundColor = 'rgba(0, 255, 0, 0.1)';
                                        e.target.style.border = '1px solid #00FF00';
                                    }}
                                    onMouseLeave={e => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.border = '1px solid transparent';
                                    }}
                                    title='Clique para editar o valor'
                                >
                                    {parseFloat(veiculo.valorFipe).toLocaleString('pt-BR', {
                                        style: 'currency', currency: 'BRL',
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}
                                </div>
                                ) 
                                : 
                                (
                                // Se não tem valor, mostrar botão para adicionar
                                <span
                                    onClick={!veiculo.modelo ? null : abrirEdicaoValorFipe}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',       
                                        color: '#ffffffff',
                                        fontSize: '13px',
                                        marginTop: '3px',
                                        fontWeight: 'bold',
                                        border: 'none',
                                        cursor: veiculo.modelo ? 'pointer' : 'not-allowed',
                                        transition: 'all 0.3s ease',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    ➕ Valor FIPE
                                </span>
                                )}
                            </div>
                            
                            {rotaCotacao &&
                            <div className='listaFlexCol'>
                                <span style={{ color: '#FFD700', fontSize: '12px' }}>VALOR PLANO:</span>
                                <span style={{ color: '#0099ffff', fontWeight: 'bold', fontSize: 'clamp(12px, 3vw, 15px)' }}>
                                    {props.valorMensalCotac ? parseFloat(props.valorMensalCotac).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) : '-'}
                                </span>
                            </div>
                            }
                            </>}
                        </div>

                        <div style={{ display: 'flex',gap: '10px',marginBottom: '15px'}}>
                            <div className='listaFlexCol'>
                                <span style={{ color: '#FFD700', fontSize: '12px' }}>COR:</span>
                                <span style={{ color: 'white', fontWeight: 'bold' }}>
                                    {veiculo?.cor }
                                </span>
                            </div>
                            

                            <div className='listaFlexCol'>
                                <span style={{ color: '#FFD700', fontSize: '12px' }}>SITUAÇÃO:</span>
                                <span style={{ color: 'white', fontWeight: 'bold' }}>
                                    {veiculo?.situacao }
                                </span>
                            </div>
                        </div>
                        

                        {/* Botões condicionais */}
                        <div style={{ 
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '10px',
                            marginTop: '15px'
                        }}>
                            {props.situacaoDivergente ? (
                                // Mensagem quando situação é divergente
                                <div style={{
                                    color: '#FF4444',
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    textAlign: 'center',
                                    padding: '10px'
                                }}>
                                    ❌ Atenção: Veículo com situação irregular ({veiculo?.situacao})
                                </div>
                            )
                            :
                            !props.dadosDivergentes && (
                                // Mensagem quando dados estão iguais
                                <div style={{ 
                                    color: '#00D594',
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    textAlign: 'center',
                                    padding: '10px'
                                }}>
                                    ✓ Dados do veículo estão atualizados
                                </div>
                            )}
                        </div>
                    </div>
                </S.div3>
                

                 <S.div3>
                    {/* Indicador de busca de dados da placa */
                    props.buscandoDadosPlaca && 
                        <div style={{ 
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '10px',
                            marginTop: '10px',
                            backgroundColor: 'rgba(0, 123, 255, 0.1)',
                            width: '90%',
                            maxWidth: '500px'
                        }}>
                            <span style={{ color: '#007bff', fontSize: '14px', fontWeight: 'bold' }}>
                                🔄 Buscando dados da placa na FIPE...
                            </span>
                        </div>
                    }

                    { /* Mensagem de sucesso */
                    props.sucessoBuscaPlaca && 
                        <div style={{ 
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '10px',
                            marginTop: '10px',
                            backgroundColor: 'rgba(0, 255, 0, 0.1)',
                            width: '90%',
                            maxWidth: '500px'
                        }}>
                            <span style={{ color: '#00ff00', fontSize: '14px', fontWeight: 'bold' }}>
                                ✅ Dados da placa carregados com sucesso!
                            </span>
                        </div>
                    }

                    {/* Mensagem de erro */}
                    {props.erroBuscaPlaca && (
                        <div style={{ 
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '10px',
                            marginTop: '10px',
                            backgroundColor: 'rgba(255, 68, 68, 0.1)',
                            borderRadius: '8px',
                            width: '95vw',
                            maxWidth: '500px'
                        }}>
                            <span style={{ color: '#ff4444', fontSize: '14px', fontWeight: 'bold' }}>
                                ❌ {props.erroBuscaPlaca}
                            </span>
                        </div>
                    )}
                </S.div3>
            </S.Container>
        </S.body>
    );
}
